export default function createScreens(screens: any) {
  return {
    ...screens,
    phone: 320,
    largePhone: 500,
    phablet: screens.sm,
    tablet: screens.md,
    largeTablet: 920,
    laptop: screens.lg,
    desktop: screens.xl,
    largeDesktop: screens['2xl'],
  };
}
